import errorReducer from '../common/redux-error'
import handleConfigState from './config'
import handleEnvironmentState from './environment'
import handleFetchState from './fetch-state'
import handleIntlState from './intl'
import handlePushState from './push'
import handleSchedules from './schedules'
import socketInstanceReducer from './socket'

const rootReducer = {
    config: handleConfigState,
    environment: handleEnvironmentState,
    errors: errorReducer,
    fetchState: handleFetchState,
    intl: handleIntlState,
    pushState: handlePushState,
    schedules: handleSchedules,
    socket: socketInstanceReducer
}

export default rootReducer
